var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.showing,"max-width":"290"},on:{"input":_vm.handleClose}},[_c(_vm.component,_vm._b({tag:"component",on:{"onClose":_vm.handleClose}},'component',_vm.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }